import { render, staticRenderFns } from "./CardPacienteSelecionado.vue?vue&type=template&id=91487c20&scoped=true"
import script from "./CardPacienteSelecionado.vue?vue&type=script&lang=js"
export * from "./CardPacienteSelecionado.vue?vue&type=script&lang=js"
import style0 from "./CardPacienteSelecionado.vue?vue&type=style&index=0&id=91487c20&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91487c20",
  null
  
)

export default component.exports